import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { ButtonDirective } from '@openng/optimus-ui/button';

@Component({
  selector: 'app-location-mobile-filter',
  templateUrl: './location-mobile-filter.component.html',
  styleUrls: ['./location-mobile-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateDirective,
    FormsModule,
    InputText,
    ButtonDirective,
    TranslatePipe,
  ],
})
export class LocationMobileFilterComponent {
  readonly mobileFilterEvent = output<any>();

  state: string | null = null;
  county: string | null = null;
  township: string | null = null;

  mobileFilter() {
    this.mobileFilterEvent.emit({
      state: this.state,
      county: this.county,
      township: this.township,
    });
  }

  clear() {
    this.state = null;
    this.county = null;
    this.township = null;
    this.mobileFilter();
  }
}
